(function () {
  console.log("entered");
  function closeItem(item) {
    var trigger = item.querySelector('[data-beato-faq-trigger]');
    var panel = item.querySelector('[data-beato-faq-panel]');

    if (!trigger || !panel) return;

    item.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
  }

  function openItem(item) {
    var trigger = item.querySelector('[data-beato-faq-trigger]');
    var panel = item.querySelector('[data-beato-faq-panel]');

    if (!trigger || !panel) return;

    item.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
  }

  function initBeatoFaq(root) {
    var scope = root || document;
    var accordions = scope.querySelectorAll('[data-beato-faq-accordion]');

    accordions.forEach(function (accordion) {
      if (accordion.dataset.initialized === 'true') return;
      accordion.dataset.initialized = 'true';

      accordion.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-beato-faq-trigger]');
        console.log("clicked");
        if (!trigger || !accordion.contains(trigger)) return;
        console.log("not returned");

        var item = trigger.closest('[data-beato-faq-item]');
        if (!item) return;
        console.log("item found");

        var isOpen = item.classList.contains('is-open');
        var items = accordion.querySelectorAll('[data-beato-faq-item]');

        items.forEach(function (otherItem) {
          closeItem(otherItem);
        });

        if (!isOpen) {
          openItem(item);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initBeatoFaq(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initBeatoFaq(event.target);
  });

  document.addEventListener('shopify:section:reorder', function (event) {
    initBeatoFaq(event.target);
  });
})();